module.exports = __webpack_public_path__ + "img/canvas.1ca3541a.png";